// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './config';
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import store from './vueX';
import axios from './axios';
import sockets from './socket';

//适配
// import './common/js/flexible'

/** 引入element */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

// 基础样式
import './common/stylus/base.styl';

// ajax
import { ajax } from './common/js/ajax';
Vue.prototype.$ajax = ajax;

// 全屏预览图片
import viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css'
Vue.use(viewer);

// 头像去缓存
import { avatarHash } from '@/common/js/avatar';
Vue.prototype.$avatarHash = avatarHash;

// auth_code转换成具体身份
import { authCodeT } from '@/common/js/authCodeT';
Vue.prototype.$authCodeT = authCodeT;

// iview
import '@/common/js/iview';
import 'iview/dist/styles/iview.css';
import './common/config.less'

// iconfont
import './common/iconfont/iconfont.css'

// 自定义指令
import clickOutSide from './common/directives/clickOutSide';
import scrollUnique from './common/directives/scrollUnique';
import onlyNum from './common/directives/onlyNum';
Vue.directive('clickOutSide', clickOutSide);
Vue.directive('scrollUnique', scrollUnique);
Vue.directive('onlyNum', onlyNum);

Vue.config.productionTip = false;

Vue.prototype.$gotoCompany = function (link, ishref) {
  link = link || '/';
  if( !ishref ){
    if( process.env.NODE_ENV == 'production' ) {
      if(window.location.origin == 'https://www-test.honsenflag.com'){
        // window.location.href = 'https://company-test.honsenflag.com/' + link;
        window.open('https://company-test.honsenflag.com/' + link, "_blank")
      }else if(window.location.origin == 'https://www.honsenflag.com'){
        // window.location.href = 'https://company.honsenflag.com/' + link;
        window.open('https://company.honsenflag.com/' + link, "_blank")
      }
    }else{
      // window.location.href = '//192.168.1.104:8880/' + link;
      window.open('//192.168.1.104:8880/' + link, "_blank")
    }
  }else{
    if( process.env.NODE_ENV == 'production' ) {
      if(window.location.origin == 'https://www-test.honsenflag.com'){
        return window.location.href = 'https://company-test.honsenflag.com/' + link;
      }else if(window.location.origin == 'https://www.honsenflag.com'){
        return window.location.href = 'https://company.honsenflag.com/' + link;
      }
    }else{
      return '//192.168.1.104:8880/' + link;
    }
  }
};

Vue.prototype.$gotoLawyer = function (link, ishref) {
  link = link || '/';
  if( !ishref ){
    if( process.env.NODE_ENV == 'production' ) {
      if(window.location.origin == 'https://www-test.honsenflag.com'){
        // window.location.href = 'https://lawyer-test.honsenflag.com/' + link;
        window.open('https://lawyer-test.honsenflag.com/' + link, "_blank")
      }else if(window.location.origin == 'https://www.honsenflag.com'){
        // window.location.href = 'https://lawyer.honsenflag.com/' + link;
        window.open('https://lawyer.honsenflag.com/' + link, "_blank")
      }
    }else{
      // window.location.href = '//192.168.1.104:8888/' + link;
      window.open('//192.168.1.104:8888/' + link, "_blank")
    }
  }else{
    if( process.env.NODE_ENV == 'production' ) {
      if(window.location.origin == 'https://www-test.honsenflag.com'){
        return window.location.href = 'https://lawyer-test.honsenflag.com/' + link;
      }else if(window.location.origin == 'https://www.honsenflag.com'){
        return window.location.href = 'https://lawyer.honsenflag.com/' + link;
      }
    }else{
      return '//192.168.1.104:8888/' + link;
    }
  }
};

// 入口
function getMine(callback) {
  let mineURL = 'userinfo/mine';
  axios.get(mineURL).then((response) => {
    let data = response.data;
    if (data.retcode === $conf.RETCODE_OK) {

      let defaultlocation = ['广东省', '深圳市'];
      axios.get('getip').then((res) =>{
        let data = res.data;
        if( data.ip_province !== '' && data.ip_city !== '' ){
          defaultlocation = [data.ip_province, data.ip_city];
        }
        store.commit('changeLocationCity', defaultlocation);
      }).catch(error =>{
        store.commit('changeLocationCity', defaultlocation);
      })

      // if (data.data.phone === null || data.data.phone === '') {
      //   store.commit('changebindPhone', true)
      // }
      store.commit('changeloginStatus', true);
      store.commit('changeMineInfo', data.data);
      sockets(data.data.id);
    } else {
      console.log(data.errmsg);
    }
    if (callback) callback();
  }).catch(error => {
    if (callback) callback();
  });
}

getMine(function () {
  new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
  });
});



// WEBPACK FOOTER //
// ./src/main.js